import { useTranslator } from '@Localization';
import { AutocompleteOption } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { AddIcon } from '../../../../design/static/icons/AddIcon';
import { RowLayout } from '../../../../modules/common/layouts/rowLayout/RowLayout';
import { ValidatedSelectInput } from '../../../components/ValidatedSelectInput';
import { EnableFor } from '../../../containers/EnableForRole';
import { IProjectAvailableDatasetDto } from '../projectDetails.models';
import { useProjectDetailsPermissions } from '../projectDetails.permissions';

interface IProjectDatasetsFormProps {
  projectId: string;
  workspaceId: string;
  selectedDatasetId?: string;
  datasets: IProjectAvailableDatasetDto[];
  onDatasetAddedAsync: () => Promise<void>;
  onSelectedDatasetChanged: (datasetId: string) => void;
}

export const ProjectDatasetsForm = observer((props: IProjectDatasetsFormProps): ReactElement => {
  const { t } = useTranslator();
  const permissions = useProjectDetailsPermissions();

  return (
    <RowLayout
      size='md'
      className='add-dataset-container'
    >
      <EnableFor hasPermission={permissions.canUnlinkDataset()}>
        <ValidatedSelectInput
          id='dataset-dropdown'
          name='select'
          options={props.datasets}
          value={props.datasets.find((a) => a.id === props.selectedDatasetId)}
          getOptionLabel={(o) => o.name}
          placeholder={t('choose_dataset')}
          onChange={(_, v) => {
            props.onSelectedDatasetChanged(v.id);
          }}
          renderOption={(props, option) => {
            const published = option.status === 'Published';
            return (
              <AutocompleteOption {...props}>
                <div className={classNames({ 'not-published-dataset': !published })}>{`${option.name} ${!published ? `(${t('not_published')})` : ''}`}</div>
              </AutocompleteOption>
            );
          }}
        />
        <ButtonWithLoader
          color='primary'
          onClick={props.onDatasetAddedAsync}
          disabled={props.selectedDatasetId === undefined}
          loaderKey='add-dataset-button'
          startDecorator={<AddIcon />}
        >
          {t('add')}
        </ButtonWithLoader>
      </EnableFor>
    </RowLayout>
  );
});
